export const FETCH_NEWSBRIEF = 'FETCH_NEWSBRIEF'

export const URL_HOME = '/feedback'

export const SUBMIT_NEWSBRIEF_FEEDBACK = 'SUBMIT_NEWSBRIEF_FEEDBACK'

export const UPDATE_FEEDBACK_FIELD = 'UPDATE_FEEDBACK_FIELD'
export const UPDATE_ARTICLE_FEEDBACK_FIELD = 'UPDATE_ARTICLE_FEEDBACK_FIELD'
